import React, { useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
} from "@mui/material";
import { a11yProps, CustomTabPanel } from "../../components/Tab/CustomTabPanel";
import ListQuotation from "./ListQuotation";
import GenerateQuotation from "./GenerateQuotation/GenerateQuotation";
import ConfirmationModal from "../common/ConfirmationModal";

const QuotationTabs = () => {
  const [value, setValue] = useState(0);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [pendingTab, setPendingTab] = useState<number | null>(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    if (unsavedChanges && value === 1) {
      setPendingTab(newValue);
      setShowConfirmDialog(true);
    } else {
      setValue(newValue);
    }
  };

  const handleConfirmLeave = () => {
    setShowConfirmDialog(false);
    setUnsavedChanges(false);
    if (pendingTab !== null) {
      setValue(pendingTab);
      setPendingTab(null);
    }
  };

  const handleCancelLeave = () => {
    setShowConfirmDialog(false);
    setPendingTab(null);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleTabChange}
          aria-label="quotation tabs"
        >
          <Tab label="List Quotations" {...a11yProps(0)} />
          <Tab label="Generate Quotation" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <ListQuotation />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <GenerateQuotation setUnsavedChanges={setUnsavedChanges} />
      </CustomTabPanel>

      <ConfirmationModal
        open={showConfirmDialog}
        onClose={handleCancelLeave}
        onConfirm={handleConfirmLeave}
      >
        You have unsaved changes. If you leave this page now, your changes will
        be lost. Are you sure you want to leave?
      </ConfirmationModal>
    </Box>
  );
};

export default QuotationTabs;
